// Module
var code = "<div class=\"alert-error\"> <span [innerHTML]=\"message\"></span> </div> ";
// Exports
export default code;